import { useRouter } from 'next/router';
import type { Filters } from '@/domain';
import { parseUrl } from '@/scenes/resultPage/helpers';

export const SmallFhhMap = ({ filters }: { filters: Filters }) => {
    const router = useRouter();
    const searchParams = parseUrl(router.query);

    const midpointParams = (latSw, lngSw, latNe, lngNe) =>
        `lat=${(Number.parseFloat(latSw) + Number.parseFloat(latNe)) / 2}&lng=${(Number.parseFloat(lngSw) + Number.parseFloat(lngNe)) / 2}`;

    const zoomLevel = filters.country ? 3 : 6;
    const mapCoords =
        filters.lng_sw && filters.lat_sw && filters.lng_ne && filters.lat_ne
            ? midpointParams(filters.lat_sw, filters.lng_sw, filters.lat_ne, filters.lng_ne)
            : 'lat=59.925668&lng=10.762596'; // Oslo
    const imageUrl = `https://maptiles.finncdn.no/staticmap?${mapCoords}&zoom=${zoomLevel}&maptype=norwayVector&showPin=false&size=590x194`;

    return (
        <div className="relative mb-8 mini-map map-image-button" data-testid="miniMap">
            <a href={`${router.basePath}/kart/?${searchParams.toString()}`}>
                <img src={imageUrl} alt="Vis i kart" className="w-full clickable rounded-8" />
            </a>
        </div>
    );
};
